<template>
    <div class="container-mp"
    @touchstart="touchStartHandler"
    @touchend="touchEndHandler">
        <div class="lucida-icon-mp">
            <img src="../../assets/image/index_v2/Group.svg" alt="">
        </div>
        <div class="main-box-mp">
            <div class="title-mp">
                <div><span class="emphasize-mp">Lucida is a</span></div>
                <div>multi-strategy</div>
                <div>hedge fund</div>
                <div>built for</div>
                <div><span class="emphasize-mp">Bitcoin trading</span></div>
            </div>
            <div class="user-info-mp">
                <div class="info-item-mp">
                    It has leading performance in arbitrage,<br />
                    market-making, and directional strategies.
                </div>
                <div class="info-item-mp">
                    Its team consists of over 20 experienced<br />
                    researchers and asset managers based in<br />
                    Hong Kong, London and New York.
                </div>
                <div class="info-item-mp">
                    Lucida was founded in 2018<br />
                    by Naiqian Zheng
                </div>
                <div class="info-item-mp">
                    and its co-managing partners are<br />
                    Fabian Bjorklund and Hao Guang
                </div>
            </div>
            <div class="contact-info-mp">
                <div class="line-left-mp"></div>
                <div class="contact-item-mp">
                    <span>For inquiries please contact info</span>&nbsp;<span class="contact-item-wmp">contact@lucida.fund</span><br />
                    <span>Exceptional people should contact</span>&nbsp;<span class="contact-item-wmp">work@lucida.fund</span>
                </div>
            </div>
        </div>
        <div class="bottom-box">
            <div class="line-mp"></div>
            <div class="bottom-info-mp">
                <div class="btminfo-mp">
                    Lucida's funds are registered in the Cayman Islands.<br />
                    Lucida does not solicit or accept retail investment.<br />
                    <hr>
                </div>
            </div>
            <div class="btmlink-mp">
                <span class="copyright">Copyright 2025</span>
                <img class="jump-to-1" src="../../assets/image/index_v2/Group 27153.svg" alt="">
                <img class="jump-to-2" src="../../assets/image/index_v2/Group 27154.svg" alt="">
                <img class="jump-to-3" src="../../assets/image/index_v2/Group 27157.svg" alt="">
                <img class="jump-to-4" src="../../assets/image/index_v2/Group 27156.svg" alt="">
                <img class="jump-to-5" src="../../assets/image/index_v2/Group 27158.svg" alt="">
            </div>
        </div>
    </div>
</template>

<style>
    @font-face {
        font-family: "PalanquinDark-Bold";
        src: url("../../assets/fonts/index_v2/PalanquinDark-Bold.ttf");
    }
    @font-face {
        font-family: "PalanquinDark-Medium";
        src: url("../../assets/fonts/index_v2/PalanquinDark-Medium.ttf");
    }
    @font-face {
        font-family: "PalanquinDark-Regular";
        src: url("../../assets/fonts/index_v2/PalanquinDark-Regular.ttf");
    }
    @font-face {
        font-family: "PalanquinDark-SemiBold";
        src: url("../../assets/fonts/index_v2/PalanquinDark-SemiBold.ttf");
    }
    .container-mp {
        position: relative;
        height: 100%;
        color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .main-box-mp {
        position: relative;
        height: 71%;
        margin: 0px 16px;
        display: flex;
        justify-content: center;
        flex-direction: column;
    }
    .lucida-icon-mp{
        position: absolute;
        top: 24px;
        left: 16px;
    }
    .lucida-icon-mp>img{
        width: 100px;
    }
    .title-mp {
        font-family: PalanquinDark-Medium;
        font-size: 36px;
        transition: transform 0.5s ease, opacity 0.5s ease;
    }
    .title-mp>div{
        display: flex;
        align-items: center;
        height: 50px;
        overflow: hidden;
    }
    .user-info-mp{
        font-family: PalanquinDark-Regular;
        line-height: 14px;
        position: absolute;
        right: 0px;
        bottom: 65px;
        text-align: right;
        opacity: 0;
        transition: opacity 0.5s ease;
    }
    .info-item-mp{
        margin-top: 8px;
        font-size: 14px;
    }
    .contact-info-mp{
        position: absolute;
        left: 0px;
        bottom: 0px;
        font-size: 12px;
        margin-top: 20px;
        padding-left: 6px;
        opacity: 0;
        transition: opacity 0.5s ease;
    }
    .contact-item-mp{
        font-family: PalanquinDark-Regular;
        line-height: 16px;
    }
    .contact-item-wmp{
        font-family: PalanquinDark-Bold;
        font-size: 14px;
    }
    .line-left-mp{
        width: 1px;
        height: 60px;
        position: absolute;
        bottom: 0px;
        left: 0;
        background-color: #fff9;
    }
    .emphasize-mp{
        background-color: #0045FF;
    }
    .line-mp{
        height: 1px;
        background-color: #fffa;
    }
    .bottom-box{
        position: absolute;
        width: 100%;
        bottom: 4px;
    }
    .bottom-box>div{
        margin: 0px 16px;
    }
    hr {
        background-color: #fffa;
        height: 1px;
        border: none;
    }
    .bottom-info-mp{
        display: flex;
        justify-content: right;
        padding-top: 4px;
    }
    .btminfo-mp{
        font-family: PalanquinDark-Regular;
        font-size: 10px;
        line-height: 14px;
        display: inline-block;
        text-align: right;
    }
    .btmlink-mp{
        position: relative;
        display: flex;
        justify-content: center;
        margin-bottom: 14px;
    }
    .btmlink-mp>img{
        margin: 6px;
        width: 24px;
    }
    .copyright{
        font-family: PalanquinDark-Regular;
        position: absolute;
        right: 0;
        bottom: 0;
        font-size: 10px;
        opacity: .6;
    }
</style>

<script>
export default {
  data() {
    return {
        pageCount: 0,
        pageTotal: 2,
        startX: 0,
        startY: 0,
    };
  },
  methods: {
    touchStartHandler(e) {
        e.preventDefault();
        this.startX = e.changedTouches[0].pageX,
        this.startY = e.changedTouches[0].pageY;
    },
    touchEndHandler(e) {
        e.preventDefault();
        switch (e.target.className) {
            case 'jump-to-1':
            window.open('https://x.com/lucidafund');
                break;
            case 'jump-to-2':
            window.open('https://mirror.xyz/lucidafund.eth');
                break;
            case 'jump-to-3':
            window.open('https://www.linkedin.com/company/81970900');
                break;
            case 'jump-to-4':
            window.open('https://medium.com/@Lucida_and_Falcon');
                break;
            case 'jump-to-5':
            window.open('https://github.com/lucidagithub');
                break;
            default:
                break;
        }
        let x = e.changedTouches[0].pageX - this.startX;
        let y = e.changedTouches[0].pageY - this.startY;
        let abs_x = (x > 0 ? x : -x);
        let abs_y = (y > 0 ? y : -y);
        // 当 |y| > |x| 时，为上/下滑 ( |y|必需大于最小滑动值 )
        if(abs_y > abs_x && abs_y > 30) {
            let title = document.querySelector('.title-mp');
            let userInfo = document.querySelector('.user-info-mp');
            let contactInfo = document.querySelector('.contact-info-mp');
            if(y < 0) {
                let h = document.body.clientHeight * 0.2;
                title.style.transform = `translateY(-${h}px)`;
                title.style.opacity = '0.5';
                userInfo.style.opacity = '1';
                contactInfo.style.opacity = '1';
            }
            else if(y > 0) {
                title.style.transform = 'translateY(0)';
                title.style.opacity = '1';
                userInfo.style.opacity = '0';
                contactInfo.style.opacity = '0';
            }
        }
    },
  },
};
</script>